import React, { useEffect, useState } from 'react'
import {
  IconButton,
  Typography,
  Card,
  CardContent,
  Grid,
  Paper,
  Button
} from '@material-ui/core'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import LambdaFetch from '../functions/FetchFromLambda'
import fetchFromAthena from '../functions/FetchFromAthena'
import { makeStyles } from '@material-ui/core/styles'
import SimpleAutoComplete from '../functions/SimpleAutoComplete'
import { AntTabs } from '../components/VendorTabs'
import { VendorInvoices } from '../components/VendorInvoices'
import VendorLocations from '../components/VendorLocations'
import LoadingCircle from '../components/common/LoadingCircle'
import VendorPos from '../components/VendorPos'
import { smallScreenWidth } from '../constants/AppConstants'
import LoadingButton from '../components/LoadingButton'
import { dateFormat } from '../utils/formatter'
import { VendorInvoicesServerSide } from '../components/VendorInvoicesServerSide'
import { VendorPosServerSide } from '../components/VendorPosServerSide'
import { VendorBank } from '../components/VendorBank'
import OpenSearchDropdown from '../components/OpenSearchDropdown'
import { getSubpagesByModule } from '../config/permissions-registry'
import DocumentList from '../components/DocumentList'
import VendorAgreementsTable from '../components/VendorAgreementsTable'
import RecordExportButton from '../components/RecordExportButton'
import { vendorExportConfig } from '../config/exportConfigs'
import CommentsPanel from '../components/CommentsPanel'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    margin: '2rem 1rem'
  },
  paper: {
    padding: theme.spacing(2),
    color: 'rgba(0,0,0,0.9)',
    height: '100%'
  },
  descript: { fontSize: '0.8rem', color: '#545454' },
  descriptVal: { fontSize: '0.85rem' }
}))

export default function Vendor (props) {
  const classes = useStyles()
  const { credentials } = props.fetchInitialData
  const [state, setstate] = useState({
    groups: [],
    selectedVendor: '',
    vendorData: null,
    invoices: [],
    locations: [],
    pos: [],
    bankInfo: null,
    fetched: true,
    isLoading: false
  })
  const [vendor, setVendor] = React.useState('')
  const [selectedGroup, setSelectedGroup] = useState('')
  const [tabVal, setTabVal] = useState(0)
  const [clearHeader, setClearHeader] = React.useState(false)
  const [clearTrigger, setClearTrigger] = React.useState(false)


  const allow = credentials?.allow || (() => false)
  // AP subpage checks
  const allowAP = (subkey) => allow('subpage', 'AP', subkey)


  const handleSubmit = async e => {
    e.preventDefault()
    getVendor(vendor)
  }

  const getVendor = async id => {
    try {
      setstate({ ...state, isLoading: true })
      if (!id) return null

      const queries = ['ap_vendor_main_read', 'ap_venloc_read']

      queries.push(`ap_vendor_bank_read${allowAP('bank') ? '' : 'false'}`)

      const data = await Promise.allSettled(
        queries.map(query =>
          fetchFromAthena({
            queryName: query,
            headers: {
              vendorGroup: selectedGroup,
              vendor: id
            },
            accessToken: credentials.user.accessToken,
            credentials: credentials
          })
        )
      ).then(results => {
        return results
      })

      if(!data[0].value[0]) {
        props.createSnack('Vendor not found or secured', 'warning', 3000)
        return
      }

      setstate({
        ...state,
        vendorData: transformData(data[0].value[0]),
        locations: data[1].value,
        bankInfo: data[2].value ? data[2].value[0] : null,
        isLoading: false
      })
      setTabVal(0)
    } catch (e) {
      setstate({
        ...state,
        isLoading: false
      })
      console.log(e)
    }
  }

  const transformData = obj => {
    obj['PHONE_NUM'] = `${obj['PHONE_PREFIX']} ${obj['PHONE_NUM']}`
    obj['FAX_NUM'] = `${obj['FAX_PREFIX']} ${obj['FAX_NUM']}`
    obj['MOBILE_NUM'] = `${obj['MBL_INT_PREFIX']} ${obj['MOBILE_NUM']}`
    return obj
  }
  const printValue = (dataObj, lookup, description, secondary, secondType) => {
    const isDate = description.toLowerCase().indexOf('date') !== -1

    return (
      <div>
        <span className={classes.descript}>{`${description}:  `}</span>
        <span className={classes.descriptVal}>
          {`${isDate ? dateFormat(dataObj[lookup]) : dataObj[lookup]}${
            secondary && dataObj[secondary]
              ? ` (${
                  secondType !== 'date'
                    ? dataObj[secondary]
                    : dateFormat(dataObj[secondary])
                })`
              : ''
          } `}
        </span>
      </div>
    )
  }
  const { vendorData } = state

  const vendorTabs = ['Main']

  allowAP('invoices') && vendorTabs.push('Invoices')
  allowAP('locations') && vendorTabs.push('Locations')
  allowAP('po') && vendorTabs.push('PO')
  allowAP('bank') && vendorTabs.push('Bank')
  allowAP('agreements') && vendorTabs.push('Vendor Agreements')
  
  if (!state.fetched) {
    return <LoadingCircle />
  }
  return (
    <div style={{ padding: '1.5rem 0.5rem' }}>
      <IconButton
        style={{ borderRadius: '5px', position: 'absolute' }}
        size='small'
        onClick={() => props.history.push('/')}
        aria-label='delete'
      >
        <ArrowBackIcon />
        {props.fetchInitialData.credentials.appWidth > smallScreenWidth &&
          'Dashboard'}
      </IconButton>
      <Typography variant='h5' style={{ textAlign: 'center' }}>
        Accounts Payable
      </Typography>

      <div className={classes.root}>
        <Paper elevation={0} style={{ padding: '1rem' }}>
          <form onSubmit={handleSubmit}>
            <Grid
              container
              alignContent='center'
              alignItems='flex-start'
              spacing={2}
            >
              <Grid item>
                <OpenSearchDropdown
                  id='group'
                  required
                  width='250px'
                  label='Vendor Group'
                  page="VENDOR"
                  entity="VENDORGROUP"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  onChange={(val) => {
                    setSelectedGroup(val?.VALUE || null)
                  }}
                />
              </Grid>
              <Grid item>
                <OpenSearchDropdown
                  id='vendor'
                  required
                  disabled={!selectedGroup}
                  width='300px'
                  label='Vendor'
                  page="VENDOR"
                  entity="VENDOR"
                  searchFields={['DISPLAY']}
                  accessToken={credentials.user.accessToken}
                  credentials={credentials}
                  clearTrigger={clearTrigger}
                  filters={{
                    VENDORGROUP: selectedGroup
                  }}
                  onChange={(val) => {
                    setVendor(val?.VALUE || null)
                  }}
                />
              </Grid>
            </Grid>
            <div style={{ marginTop: '1rem' }}>
              <LoadingButton
                label='Submit'
                isLoading={state.isLoading}
                color='primaryVLButton'
                buttonType='submit'
              />
              {!!(vendor || selectedGroup) && (
                <Button
                  onClick={() => {
                    setClearHeader(!clearHeader)
                    setVendor('')
                    setSelectedGroup('')
                    setClearTrigger(prev => !prev)
                    setstate({ ...state, vendorData: null, locations: [], pos: [], bankInfo: null })
                  }}
                  style={{ marginLeft: '0.5rem' }}
                >
                  Clear
                </Button>
              )}
            </div>
          </form>
        </Paper>

        {!!state.vendorData && (
          <Card style={{ marginTop: '1rem' }}>
            <CardContent style={{ position: 'relative' }}>
              <div
                style={{
                  display: 'flex',
                  marginTop: '0.5rem',
                  justifyContent: 'flex-start'
                }}
              >
                <div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography variant='h5'>
                      {state.vendorData.VENDOR_VNAME}
                    </Typography>
                    <RecordExportButton
                      recordData={state}
                      sections={vendorExportConfig}
                      fileName={`Vendor_${state.vendorData.VENDOR_VNAME.replace(/\s+/g, '_')}`}
                      createSnack={props.createSnack}
                    />
                    {credentials.user.roleActions?.comments?.view && (
                      <CommentsPanel
                        module="VENDOR"
                        recordKey={[
                          { field: 'vendorGroup', value: selectedGroup },
                          { field: 'vendor', value: vendor },
                        ]}
                        credentials={credentials}
                        createSnack={props.createSnack}
                      />
                    )}
                  </div>
                  <Typography variant='subtitle1'>{`Vendor Group: ${state.vendorData.VENDOR_GROUP}`}</Typography>
                </div>
              </div>
              <DocumentList 
                      path={`vendors/${vendorData.VENDOR_GROUP}/${vendorData.VENDOR.trim()}`}
                      credentials={credentials}
                      linkText="View Documents"
                      title="Vendor Documents"
                      baseFolderLabel=""
                      documentPermission="vendor"
                      key={`${vendorData.VENDOR_GROUP}_${vendorData.VENDOR}`}
                  />
              <AntTabs
                value={tabVal}
                color={credentials.primaryAppColor}
                handleChange={(event, newValue) => {
                  setTabVal(newValue)
                }}
                tabs={vendorTabs}
              />

              <div style={{ marginTop: '1rem' }}>
                {tabVal === 0 && (
                  <Grid
                    container
                    spacing={1}
                    direction='row'
                    justifyContent='flex-start'
                    alignItems='stretch'
                  >
                    <Grid item xs={12} sm={12} md={8}>
                      <Paper elevation={3} className={classes.paper}>
                        <Typography variant='h5'>Main</Typography>
                        <Grid
                          container
                          spacing={0}
                          direction='row'
                          justifyContent='space-evenly'
                          alignItems='flex-start'
                        >
                          <Grid item xs={12} sm={6} md={6}>
                            {printValue(
                              vendorData,
                              'VEN_CLASS',
                              'Vendor Class'
                            )}
                            {printValue(
                              vendorData,
                              'PROC_GRP',
                              'Process Group'
                            )}
                            {printValue(vendorData, 'TAX_ID', 'Tax ID')}
                            {printValue(vendorData, 'PAY_VENDOR', 'Pay Vendor')}
                            {printValue(
                              vendorData,
                              'VENDOR_STATUS',
                              'Vendor Status'
                            )}
                            </Grid>
                              <Grid item xs={12} sm={6} md={6}>
                            {printValue(
                              vendorData,
                              'INCOME_CODE',
                              'Income Code'
                            )}
                             {printValue(
                              vendorData,
                              'TERM_CODE',
                              'Payment Terms',
                              'TERM_DESC'
                            )} 
                            {printValue(
                              vendorData,
                              'CASH_CODE',
                              'Cash Code',
                              'CASH_CODE_DESC'
                            )} 
                            {printValue(
                              vendorData,
                              'BANK_INST_CODE',
                              'Payment Code',
                              'BANK_INST_DESC'
                            )}

                            {printValue(
                              vendorData,
                              'LAST_UPDT_DATE',
                              'Last Updated'
                            )}
                          </Grid>
                        </Grid>
                      </Paper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4}>
                      <Paper elevation={3} className={classes.paper}>
                        <Typography variant='h5'>
                          Contact Information
                        </Typography>
                        <Grid
                          container
                          spacing={0}
                          direction='row'
                          justifyContent='space-evenly'
                          alignItems='flex-start'
                        >
                          <Grid item xs={12}>
                            {printValue(
                              vendorData,
                              'VENDOR_CONTCT',
                              'Contact Name'
                            )}
                            {printValue(vendorData, 'PHONE_NUM', 'Telephone')}
                            {printValue(
                              vendorData,
                              'MOBILE_NUM',
                              'Mobile Phone'
                            )}
                            {printValue(vendorData, 'FAX_NUM', 'Fax')}
                            {printValue(vendorData, 'E_MAIL_ADDRESS', 'E-mail')}
                            {printValue(vendorData, 'URL_ADDR', 'URL')}
                          </Grid>
                        </Grid>
                      </Paper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <Paper elevation={3} className={classes.paper}>
                        <Typography variant='h6'>
                          Address Information
                        </Typography>

                        <Grid
                          container
                          spacing={0}
                          direction='row'
                          justifyContent='space-evenly'
                          alignItems='flex-start'
                        >
                          <Grid item xs={12} sm={6}>
                            {printValue(vendorData, 'ADDR1', 'Address 1')}
                            {printValue(vendorData, 'ADDR2', 'Address 2')}
                            {printValue(vendorData, 'ADDR3', 'Address 3')}
                            {printValue(vendorData, 'ADDR4', 'Address 4')}
                            {printValue(
                              vendorData,
                              'CITY_ADDR5',
                              'City or Address 5'
                            )}
                            {printValue(
                              vendorData,
                              'STATE_PROV',
                              'State or Province'
                            )}
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            {printValue(
                              vendorData,
                              'POSTAL_CODE',
                              'Postal Code'
                            )}
                            {printValue(vendorData, 'COUNTY', 'County')}
                            {printValue(vendorData, 'COUNTRY', 'Country')}
                            {printValue(vendorData, 'REGION', 'Region')}
                            {printValue(vendorData, 'EFFECTIVE_DATE', 'Effective Date')}
                          </Grid>
                        </Grid>
                      </Paper>
                    </Grid>
                  </Grid>
                )}

                {tabVal === 1 && (
                  <VendorInvoicesServerSide
                    key={`${state.vendorData.VENDOR}_${state.vendorData.VENDOR_GROUP}`}
                    {...props}
                    vendor={state.vendorData.VENDOR}
                    selectedGroup={state.vendorData.VENDOR_GROUP}
                    accessToken={credentials.user.accessToken}
                    credentials={credentials}
                    fileName={`Vendor_Invoices_${state.vendorData.VENDOR_VNAME.replaceAll(
                      ' ',
                      '_'
                    )}`}
                  />
                )}
                {tabVal === 2 && (
                  <VendorLocations
                    data={state.locations}
                    fileName={`Vendor_Locations_${state.vendorData.VENDOR_VNAME.replaceAll(
                      ' ',
                      '_'
                    )}`}
                  />
                )}
                {tabVal === 3 && (
                  <VendorPosServerSide
                    key={`${state.vendorData.VENDOR}_${state.vendorData.VENDOR_GROUP}`}
                    {...props}
                    vendor={state.vendorData.VENDOR}
                    selectedGroup={state.vendorData.VENDOR_GROUP}
                    accessToken={credentials.user.accessToken}
                    credentials={credentials}
                    fileName={`Vendor_Invoices_${state.vendorData.VENDOR_VNAME.replaceAll(
                      ' ',
                      '_'
                    )}`}
                  />
                )}
                {tabVal === 4 && allowAP('bank') && (
                  <VendorBank bankInfo={state.bankInfo} />
                )}
                {tabVal === 5 && allowAP('agreements') && (
                  <VendorAgreementsTable 
                    {...props}
                    type="ap" 
                    headers={{vendorGroup: state.vendorData.VENDOR_GROUP, vendor:state.vendorData.VENDOR}} 
                    />
                )}
              </div>
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  )
}
